import { render, staticRenderFns } from "./ConfirmDialog.vue?vue&type=template&id=35c7d4c6&scoped=true"
import script from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ConfirmDialog.vue?vue&type=style&index=0&id=35c7d4c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7d4c6",
  null
  
)

export default component.exports